module.exports = __webpack_public_path__ + "img/barris.8e3814ed.jpg";